import React, { useState,useEffect } from 'react'
import authService from '../../api-authorization/AuthorizeService'
import { useSelector, useDispatch  } from 'react-redux'
import MUIDataTable, { ExpandButton } from "mui-datatables";
import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import Grid from '@mui/material/Grid';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import { selectAllEvents, fetchEvents } from './eventsSlice'
import InfoIcon from '@mui/icons-material/Info'
import HotelIcon from '@mui/icons-material/Hotel'
import CellTowerIcon from '@mui/icons-material/CellTower'
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import AssessmentIcon from '@mui/icons-material/Assessment';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

const muiCache = createCache({
    key: 'mui-datatables',
    prepend: true,
});

const EventExcerpt = ({ event }) => {
    return (
        <article >
            <h3>{event.eventName}</h3>
            <p>{event.eventDescription.substring(0, 100)}</p>
            <Link to={`/events/${event.eventId}`}>
                View Event
            </Link>
        </article>
    )
}


export default function EventsList(props) {
const muiTheme = useTheme();
const isMobile = useMediaQuery(muiTheme.breakpoints.down('sm'));

const dispatch = useDispatch()

const events = useSelector(selectAllEvents)

const eventStatus = useSelector(state => state.events.status)

const [authenticated, setAuthenticated] = useState(false);
const [isAdmin, setIsAdmin] = useState(false);
const [isOrganizer, setIsOrganizer] = useState(false);
const [isPlayer, setIsPlayer] = useState(false);
const [userName, setUserName] = useState();
const [idType, setIdType] = useState();
const [playerId, setPlayerId] = useState();
const [userRole, setUserRole] = useState("");
const [expandedRows, setExpandedRows] = useState([]);

    //if (eventStatus == 'succeeded') {
    //    alert("haha");
    //    const data = events[0].data
    //}
    const error = useSelector(state => state.events.error)

    useEffect(() => {
        async function fetchData() {
            setAuthenticated(await authService.isAuthenticated());
            var user = await authService.getUser();
            if (user != null) {
                var role = user.role;
                setUserName(user.sub);
                if (user.sub.includes("fide")) {
                    setIsPlayer(true);
                    setIdType("fide");
                    setPlayerId(user.sub.replace("fide", ""));
                } else if (user.sub.includes("affiliate")) {
                    setIsPlayer(false);
                    setIsOrganizer(true);
                }
                else if (user.sub.includes("uscf")) {
                    setIsPlayer(true);
                    setIdType("uscf");
                    setPlayerId(user.sub.replace("uscf", ""));
                }

                await setUserRole(role);
                if (role.includes('Administrators'))
                    setIsAdmin(true);
            }
            if (eventStatus === 'idle') {
                dispatch(fetchEvents())
            }
        }
        fetchData();
    }, [eventStatus, dispatch])
    //}, [eventStatus, dispatch])

    // Mobile-friendly expandable row content
    const renderExpandedRow = (rowData, rowMeta) => {
        const event = events[rowMeta.dataIndex];
        if (!event) return null;
        
        return (
            <TableRow>
                <TableCell colSpan={6} sx={{ py: 2, px: 2, backgroundColor: '#f5f5f5' }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                            <Box>
                                <Typography variant="caption" color="text.secondary">Location</Typography>
                                <Typography variant="body2">{event.eventCity}, {event.eventState}</Typography>
                            </Box>
                            <Box>
                                <Typography variant="caption" color="text.secondary">Dates</Typography>
                                <Typography variant="body2">
                                    {event.eventStartDateTime?.split("T")[0]} - {event.eventEndDateTime?.split("T")[0]}
                                </Typography>
                            </Box>
                            {event.eventRounds > 0 && (
                                <Box>
                                    <Typography variant="caption" color="text.secondary">Rounds</Typography>
                                    <Typography variant="body2">{event.eventRounds}</Typography>
                                </Box>
                            )}
                            {event.eventPrizeFund > 0 && (
                                <Box>
                                    <Typography variant="caption" color="text.secondary">Prize Fund</Typography>
                                    <Typography variant="body2">${event.eventPrizeFund}</Typography>
                                </Box>
                            )}
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center' }}>
                            <Typography variant="caption" color="text.secondary" sx={{ mr: 1 }}>Quick Links:</Typography>
                            {event.eventFlyerUrl && <a href={event.eventFlyerUrl} target="_blank" rel="noreferrer" title="Event Details"><InfoIcon color="primary" /></a>}
                            {event.eventRegistrationUrl && <a href={event.eventRegistrationUrl} target="_blank" rel="noreferrer" title="Register"><PersonAddIcon color="primary" /></a>}
                            {event.eventPairingUrl && <a href={event.eventPairingUrl} target="_blank" rel="noreferrer" title="Pairing and Results"><AssessmentIcon color="primary"/></a>}
                            {event.eventLiveGameUrl && <a href={event.eventLiveGameUrl} target="_blank" rel="noreferrer" title="Live Games"><CellTowerIcon color="primary"/></a>}
                            {event.eventHotelReservationLink && <a href={event.eventHotelReservationLink} target="_blank" rel="noreferrer" title="Hotel Reservation"><HotelIcon color="primary"/></a>}
                        </Box>
                        <Box sx={{ mt: 1 }}>
                            <Button 
                                component={Link} 
                                to={`/events/${event.eventID}`} 
                                variant="contained" 
                                color="primary"
                                size="small"
                                fullWidth
                            >
                                View Event Details
                            </Button>
                        </Box>
                    </Box>
                </TableCell>
            </TableRow>
        );
    };

    // Define columns based on screen size
    const getColumns = () => {
        if (isMobile) {
            // Mobile: Show minimal columns with expand for more details
            return [
                {
                    name: '',
                    label: '#',
                    options: {
                        filter: false,
                        sort: false,
                        setCellProps: () => ({ style: { width: '24px', padding: '4px 2px' } }),
                        customBodyRender: (value, tableMeta) => {
                            return <span style={{ fontSize: '11px', color: '#666' }}>{tableMeta.rowIndex + 1}</span>;
                        }
                    }
                },
                {
                    name: "eventName",
                    label: "Event",
                    options: {
                        filter: false,
                        sort: true,
                        setCellProps: () => ({ style: { padding: '4px' } }),
                        customBodyRender: (value, tableMeta) => {
                            let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                            let event = events[originalIndex];
                            let startDate = event.eventStartDateTime?.split("T")[0] || '';
                            let location = event.eventState ? `${event.eventState}` : '';
                            
                            return (
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
                                    <Typography variant="body2" sx={{ fontSize: '12px', fontWeight: 500, lineHeight: 1.2 }}>
                                        {value}
                                    </Typography>
                                    <Typography variant="caption" sx={{ fontSize: '10px', color: 'text.secondary', lineHeight: 1 }}>
                                        {startDate}{location ? ` • ${location}` : ''}
                                    </Typography>
                                </Box>
                            );
                        }
                    }
                },
                {
                    name: "eventPrizeFund",
                    label: "Prize Fund",
                    options: {
                        filter: false,
                        sort: true,
                        sortDirection: 'desc',
                        setCellProps: () => ({ style: { width: '55px', padding: '4px', textAlign: 'right' } }),
                        customBodyRender: (value) => {
                            if (!value || value === 0) return <span style={{ fontSize: '11px', color: '#999' }}>-</span>;
                            // Format prize fund (e.g., 5000 -> $5K, 10000 -> $10K)
                            const formatted = value >= 1000 ? `$${(value / 1000).toFixed(value % 1000 === 0 ? 0 : 1)}K` : `$${value}`;
                            return <span style={{ fontSize: '11px', fontWeight: 500 }}>{formatted}</span>;
                        }
                    }
                },
                {
                    name: "",
                    label: "",
                    options: {
                        filter: false,
                        sort: false,
                        setCellProps: () => ({ style: { width: '50px', padding: '4px 2px' } }),
                        customBodyRender: (value, tableMeta) => {
                            let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                            let event = events[originalIndex];
                            return (
                                <Button 
                                    component={Link} 
                                    to={`/events/${event.eventID}`} 
                                    variant="contained" 
                                    color="primary"
                                    size="small"
                                    sx={{ fontSize: '10px', py: 0.5, px: 1, minWidth: 'auto' }}
                                >
                                    View
                                </Button>
                            );
                        }
                    }
                }
            ];
        }
        
        // Desktop: Full columns
        return [
        {
            name: '',
            label: '',
            options: {
                filter: false,
                customBodyRender: (value, tableMeta, update) => {
                    let rowIndex = Number(tableMeta.rowIndex) + 1;
                    return (
                        <div style={{ textAlign: "right" }}><span>{rowIndex}</span></div>
                    )
                }
            }
        },
        //{
        //    name: 'eventState',
        //    label: 'State',
        //    options: {
        //        filter: true,
        //        sortThirdClickReset: true,
        //        customLabelHeadRender: (columnMeta, updateDirection) => (
        //            <th style={{ textAlign: "left", whiteSpace: "nowrap", width: "20px" }}>
        //                {columnMeta.label}
        //            </th>
        //        ),
        //    }
        //},
        {
            name: "eventLocation",
            label: "LOCATION",
            options: {
                filter: false,
                display: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "left", whiteSpace: "nowrap", width: "140px" }}>
                        {columnMeta.label}
                    </th>
                ),
                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let parentStyle = {
                        position: "absolute",
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        boxSizing: "border-box",
                        display: "block",
                        width: "100%"
                    };
                    let cellStyle = {
                        boxSizing: "border-box",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        textAlign: "left"
                    };
                    let event = events[originalIndex];
                    return (
                        <div style={{ position: "relative", height: "20px", width: "140px" }} title={value}>
                            <div style={parentStyle}>
                                <div title={value} style={cellStyle}>
                                    {"["+event.eventState+"] " +event.eventCity}
                                </div>
                            </div>
                        </div>
                    );
                }
            }
        },
        {
            name: "eventState",
            label: "State",
            options: {
                filter: true,
                display: false,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "left", whiteSpace: "nowrap", width: "30px" }}>
                        {columnMeta.label}
                    </th>
                ),
                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let parentStyle = {
                        position: "absolute",
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        boxSizing: "border-box",
                        display: "block",
                        width: "100%"
                    };
                    let cellStyle = {
                        boxSizing: "border-box",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        textAlign: "left"
                    };
                    let eventId = events[originalIndex].id;
                    return (
                        <div style={{ position: "relative", height: "20px", width: "30px" }} title={value}>
                            <div style={parentStyle}>
                                <div title={value} style={cellStyle}>
                                    {value}
                                </div>
                            </div>
                        </div>
                    );
                }
            }
        },
        {
            name: "eventCity",
            label: "CITY",
            options: {
                filter: true,
                display: false,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "left", whiteSpace: "nowrap", width: "80px" }}>
                        {columnMeta.label}
                    </th>
                ),
                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let parentStyle = {
                        position: "absolute",
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        boxSizing: "border-box",
                        display: "block",
                        width: "100%"
                    };
                    let cellStyle = {
                        boxSizing: "border-box",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        textAlign: "left"
                    };
                    let eventId = events[originalIndex].id;
                    return (
                        <div style={{ position: "relative", height: "20px", width: "80px" }} title={value}>
                            <div style={parentStyle}>
                                <div title={value} style={cellStyle}>
                                        {value}
                                </div>
                            </div>
                        </div>
                    );
                }
            }
        },
        {
            name: "eventStartDateTime",
            label: "START DATE",
            options: {
                filter: true,
                display: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "left", whiteSpace: "nowrap", width: "140px" }}>
                        {columnMeta.label}
                    </th>
                ),
                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let parentStyle = {
                        position: "absolute",
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        boxSizing: "border-box",
                        display: "block",
                        width: "100%"
                    };
                    let cellStyle = {
                        boxSizing: "border-box",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        textAlign: "left"
                    };
                    let eventId = events[originalIndex].id;
                    return (
                        <div style={{ position: "relative", height: "20px", width: "140px" }} title={value}>
                            <div style={{ textAlign: "left" }}>
                                <span>{value.split("T")[0]}</span>
                            </div>
                        </div>
                    );
                }
            }
        },
        {
            name: "eventEndDateTime",
            label: "END DATE",
            options: {
                filter: true,
                display: false,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "left", whiteSpace: "nowrap", width: "140px" }}>
                        {columnMeta.label}
                    </th>
                ),
                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let parentStyle = {
                        position: "absolute",
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        boxSizing: "border-box",
                        display: "block",
                        width: "100%"
                    };
                    let cellStyle = {
                        boxSizing: "border-box",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        textAlign: "left"
                    };
                    let eventId = events[originalIndex].id;
                    return (
                        <div style={{ position: "relative", height: "20px", width: "140px" }} title={value}>
                            <div style={{ textAlign: "left" }}>
                                <span>{value.split("T")[0]}</span>
                            </div>
                        </div>
                    );
                }
            }
        },
        {
            name: "eventType",
            label: "TYPE",
            options: {
                filter: true,
                display: false,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "left", whiteSpace: "nowrap", width: "80px" }}>
                        {columnMeta.label}
                    </th>
                ),
                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let parentStyle = {
                        position: "absolute",
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        boxSizing: "border-box",
                        display: "block",
                        width: "100%"
                    };
                    let cellStyle = {
                        boxSizing: "border-box",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        textAlign: "left"
                    };
                    let eventId = events[originalIndex].id;
                    return (
                        <div style={{ position: "relative", height: "20px", width: "80px" }} title={value}>
                            <div style={{ textAlign: "left" }}>
                                <span>{value}</span>
                            </div>
                        </div>
                    );
                }
            }
        },
        //{
        //    name: 'eventStartDateTime',
        //    label: 'Start Date',
        //    options: {
        //        filter: true,
        //        sortThirdClickReset: true,
        //        customLabelHeadRender: (columnMeta, updateDirection) => (
        //            <th style={{ textAlign: "left", whiteSpace: "nowrap", width: "20px" }}>
        //                {columnMeta.label}
        //            </th>
        //        ),
        //        customBodyRender: (value, tableMeta, updateValue) => {
        //            return (
        //                <div style={{ textAlign: "left" }}>
        //                    <span>{value.split("T")[0]}</span>
        //                </div>
        //            );
        //        }
        //    }
        //},
        //{
        //    name: 'eventType',
        //    label: 'Type',
        //    options: {
        //        filter: true,
        //        sortThirdClickReset: true,
        //    }
        //},
        //{
        //    name: 'eventFormat',
        //    label: 'Format',
        //    options: {
        //        filter: true,
        //        sortThirdClickReset: true,
        //    }
        //},
        //{
        //    name: "eventFormat",
        //    label: "FORMAT",
        //    options: {
        //        filter: true,
        //        filterType: 'multiselect',
        //        sort: true,
        //        sortThirdClickReset: true,
        //        customLabelHeadRender: (columnMeta, updateDirection) => (
        //            <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "left", whiteSpace: "nowrap", width: "80px" }}>
        //                {columnMeta.label}
        //            </th>
        //        ),
        //        customBodyRender: (value, tableMeta, updateValue) => {
        //            let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
        //            const formatObj = {
        //                INP: 'In Person',
        //                HYB: 'Hybrid',
        //                OLN: 'Online',
        //                OTH: 'Other',
        //            };
        //            let parentStyle = {
        //                position: "absolute",
        //                top: 0,
        //                right: 0,
        //                bottom: 0,
        //                left: 0,
        //                boxSizing: "border-box",
        //                display: "block",
        //                width: "100%"
        //            };
        //            let cellStyle = {
        //                boxSizing: "border-box",
        //                overflow: "hidden",
        //                textOverflow: "ellipsis",
        //                whiteSpace: "nowrap",
        //                textAlign: "left"
        //            };
        //            let eventId = events[originalIndex].id;
        //            return (
        //                <div style={{ position: "relative", height: "20px", width: "80px" }} title={value}>
        //                    <div style={{ textAlign: "left" }}>
        //                        <span>{formatObj[value]}</span>
        //                    </div>
        //                </div>
        //            );
        //        }
        //    }
        //},
        //{
        //    name: 'eventRounds',
        //    label: 'Rnd',
        //    options: {
        //        filter: true,
        //        sortThirdClickReset: true,
        //    }
        //},
        {
            name: "eventRounds",
            label: "RND",
            options: {
                filter: true,
                display: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "left", whiteSpace: "nowrap", width: "40px" }}>
                        {columnMeta.label}
                    </th>
                ),
                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let parentStyle = {
                        position: "absolute",
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        boxSizing: "border-box",
                        display: "block",
                        width: "100%"
                    };
                    let cellStyle = {
                        boxSizing: "border-box",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        textAlign: "left"
                    };
                    let eventId = events[originalIndex].id;
                    return (
                        <div style={{ position: "relative", height: "20px", width: "40px" }} title={value}>
                            <div style={parentStyle}>
                                <div title={value} style={cellStyle}>
                                    {value}
                                </div>
                            </div>
                        </div>
                    );
                }
            }
        },

        {
            name: "eventPrizeFund",
            label: "Prize",
            options: {
                filter: true,
                display: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "left", whiteSpace: "nowrap", width: "60px" }}>
                        {columnMeta.label}
                    </th>
                ),
                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let parentStyle = {
                        position: "absolute",
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        boxSizing: "border-box",
                        display: "block",
                        width: "100%"
                    };
                    let cellStyle = {
                        boxSizing: "border-box",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        textAlign: "left"
                    };
                    let eventId = events[originalIndex].id;
                    return (
                        <div style={{ position: "relative", height: "20px", width: "60px" }} title={value}>
                            <div style={parentStyle}>
                                <div title={value} style={cellStyle}>
                                    ${value}
                                </div>
                            </div>
                        </div>
                    );
                }
            }
        },

        {
            name: "eventName",
            label: "NAME",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "left", whiteSpace: "nowrap", width: "300px" }}>
                        {columnMeta.label}
                    </th>
                ),
                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let parentStyle = {
                        position: "absolute",
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        boxSizing: "border-box",
                        display: "block",
                        width: "100%"
                    };
                    let cellStyle = {
                        boxSizing: "border-box",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        textAlign: "left"
                    };
                    /*let eventId = events[originalIndex].id;*/
                    let event = events[originalIndex];
                    return (
                        <div style={{ position: "relative", height: "20px", width: "300px" }} title={value}>
                            <div style={parentStyle}>
                                <div title={value} style={cellStyle}>
                                    <Link to={`/events/${event.eventID}`}>
                                        {/*{value.substring(0, 49)}*/}
                                        {/*{value.length > 50 ? '...' : ''}*/}
                                        {value}
                                    </Link>
                                </div>
                            </div>
                        </div>
                    );
                }
            }
        },
        {
            name: "",
            label: "QUICK LINKS",
            options: {
                filter: false,
                filterType: 'multiselect',
                sort: false,
                sortThirdClickReset: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let event = events[originalIndex];
                    return (
                        <div style={{ textAlign: "left" }}>
                            {event.eventFlyerUrl ? <a href={event.eventFlyerUrl} target="_blank" title="Event Details"><InfoIcon color="primary" /></a> : <InfoIcon color="disabled"/>}
                            {event.eventRegistrationUrl ? <a href={event.eventRegistrationUrl} target="_blank" title="Register"><PersonAddIcon color="primary" /></a> : <PersonAddIcon color="disabled"/>}
                            {event.eventPairingUrl ? <a href={event.eventPairingUrl} target="_blank" title="Pairing and Results"><AssessmentIcon color="primary"/></a> : <AssessmentIcon color="disabled"/>}
                            {event.eventLiveGameUrl ? <a href={event.eventLiveGameUrl} target="_blank" title="Live Games"><CellTowerIcon color="primary"/></a> : <CellTowerIcon color="disabled"/>}
                            {event.eventHotelReservationLink ? <a href={event.eventHotelReservationLink} target="_blank" title="Hotel Reservation"> <HotelIcon color="primary"/></a> : <HotelIcon color="disabled"/>}
                           
                            {/*<FontAwesomeIcon icon={faChess} />*/}
                            {/*<FontAwesomeIcon icon={faCircleInfo} size="lg"/>*/}
                            {/*<FontAwesomeIcon icon={faClipboardUser} size="lg"/>*/}
                            {/*<FontAwesomeIcon icon={faSquarePollVertical} size="lg"/>*/}
                            {/*<FontAwesomeIcon icon={faTowerBroadcast} size="lg"/>*/}
                            {/*<FontAwesomeIcon icon={faBed} size="lg" />*/}
                        </div>
                    );
                }


            }
        },

        //{
        //    name: "fideWomenTitle",
        //    label: "Women Title",
        //    options: {
        //        filter: true,
        //        filterType: 'multiselect',
        //        sort: true,
        //        sortThirdClickReset: true,
        //        display: false,
        //        viewColumns: true
        //    }
        //},
        //{
        //    name: "fideBirthday",
        //    label: "Birthday Year",
        //    options: {
        //        filter: true,
        //        filterType: 'multiselect',
        //        sort: true,
        //        sortThirdClickReset: true,
        //        display: false,
        //        viewColumns: true
        //    }
        //},
        //{
        //    name: "fideCountry",
        //    label: "Flag",
        //    options: {
        //        filter: true,
        //        filterType: 'multiselect',
        //        sort: true,
        //        sortOrder: { name: 'id', direction: 'desc' },
        //        sortThirdClickReset: true,
        //        customBodyRender: (value, tableMeta, updateValue) => (
        //            <div>
        //                <PlayerFlag key={value} code={(value === "" || value === null || value === undefined) ? "USA" : value} />
        //            </div>
        //        )
        //    }
        //},
        //{
        //    name: "fideCountry",
        //    label: "Country",
        //    options: {
        //        filter: true,
        //        filterType: 'multiselect',
        //        sort: true,
        //        sortThirdClickReset: true,
        //        customBodyRender: (value, tableMeta, updateValue) => (
        //            <div>
        //                <span>{value ? value : "USA"}</span>
        //            </div >

        //        )
        //    }
        //},
        //{
        //    name: "uscfState",
        //    label: "State",
        //    options: {
        //        filter: true,
        //        filterType: 'multiselect',
        //        sort: true,
        //        sortThirdClickReset: true,
        //        customBodyRender: (value, tableMeta, updateValue) => (
        //            <span>
        //                {value === "" ? "--" : value}
        //            </span>
        //        )
        //    }
        //},
        //{
        //    name: "fideName",
        //    label: "Name",
        //    options: {
        //        filter: false,
        //        sort: true,
        //        sortThirdClickReset: true,
        //        customBodyRender: (value, tableMeta, updateValue) => (
        //            <span>
        //                {/*{value === "" ? tableMeta.tableData[tableMeta.currentTableData[tableMeta.rowIndex].index].uscfName : value}*/}
        //                {value ? value : players[tableMeta.currentTableData[tableMeta.rowIndex].index].uscfName}
        //            </span>
        //        )
        //    }
        //},
        //{
        //    name: "fidePlayerId",
        //    label: "FIDE ID",
        //    options: {
        //        filter: false,
        //        sort: true,
        //        sortThirdClickReset: true,
        //        customBodyRender: (value, tableMeta, updateValue) => {
        //            return (
        //                <div style={{ textAlign: "left" }}> {value != -1 ? (<a href={'https://ratings.fide.com/profile/' + value} target='_blank' rel='noreferrer'>{value}</a>) : (value)}</div>
        //            );
        //        }
        //    }
        //},
        //{
        //    name: "fideRating",
        //    label: "Elo",
        //    options: {
        //        filter: false,
        //        sort: true,
        //        sortThirdClickReset: true,
        //    }
        //},
        //{
        //    name: "fideBlitzRating",
        //    label: "FIDE Blitz",
        //    options: {
        //        filter: false,
        //        sort: true,
        //        sortThirdClickReset: true,
        //        display: false,
        //        viewColumns: true
        //    }
        //},
        //{
        //    name: "fideRapidRating",
        //    label: "FIDE Rapid",
        //    options: {
        //        filter: false,
        //        sort: true,
        //        sortThirdClickReset: true,
        //        display: false,
        //        viewColumns: true
        //    }
        //},
        //{
        //    name: "uscfPlayerId",
        //    label: "USCF ID",
        //    options: {
        //        filter: false,
        //        sort: true,
        //        sortThirdClickReset: true,
        //        customBodyRender: (value, tableMeta, updateValue) => {
        //            return (
        //                <div style={{ textAlign: "left" }}> {value != -1 ? (<a href={'http://www.uschess.org/msa/MbrDtlMain.php?' + value} target='_blank' rel='noreferrer'>{value}</a>) : (value)}</div>
        //            );
        //        }
        //    }
        //},
        //{
        //    name: "uscfRating",
        //    label: "Rating",
        //    options: {
        //        filter: false,
        //        sort: true,
        //        sortThirdClickReset: true,
        //    }
        //},
        //{
        //    name: "uscfOnlineRating",
        //    label: "USCF Online",
        //    options: {
        //        filter: false,
        //        sort: true,
        //        sortThirdClickReset: true,
        //        display: false,
        //        viewColumns: true
        //    }
        //},
        //{
        //    name: "uscfBlitzRating",
        //    label: "USCF Blitz",
        //    options: {
        //        filter: false,
        //        sort: true,
        //        sortThirdClickReset: true,
        //        display: false,
        //        viewColumns: true
        //    }
        //},
        //{
        //    name: "uscfOnlineBlitzRating",
        //    label: "USCF Online Blitz",
        //    options: {
        //        filter: false,
        //        sort: true,
        //        sortThirdClickReset: true,
        //        display: false,
        //        viewColumns: true
        //    }
        //},
        //{
        //    name: "uscfQuickRating",
        //    label: "USCF Quick",
        //    options: {
        //        filter: false,
        //        sort: true,
        //        sortThirdClickReset: true,
        //        display: false,
        //        viewColumns: true
        //    }
        //},
        //{
        //    name: "uscfOnlineQuickRating",
        //    label: "USCF Online Quick",
        //    options: {
        //        filter: false,
        //        sort: true,
        //        sortThirdClickReset: true,
        //        display: false,
        //        viewColumns: true
        //    }
        //},
        //{
        //    name: "",
        //    label: "",
        //    options: {
        //        filter: false,
        //        sort: true,
        //        sortThirdClickReset: true,
        //        customBodyRender: (value, tableMeta, updateValue) => {
        //            let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
        //            let rowPlayer = players[originalIndex];
        //            return (
        //                <div style={{ textAlign: "left" }}> <Button variant="contained" onClick={async (e) => { e.preventDefault(); await setSelectedPlayer(rowPlayer) }}>Games</Button></div>
        //            );
        //        }
        //    }
        //},
    ];
    };

    const columns = getColumns();

    const HeaderElements = () => (
        <>
            {(isOrganizer || isAdmin) &&
                <Button component={Link} to={'/Events/Add'} variant="contained" color="primary" size={isMobile ? "small" : "medium"}>+ New Event</Button>
            }
        </>
    );

    const options = {
        setTableProps: () => {
            return {
                size: 'small',
            };
        },
        filter: !isMobile,
        filterType: 'dropdown',
        responsive: isMobile ? "standard" : "vertical",
        expandableRows: isMobile,
        expandableRowsOnClick: isMobile,
        expandableRowsHeader: false,
        renderExpandableRow: isMobile ? renderExpandedRow : undefined,
        selectableRows: 'none',
        download: false,
        print: false,
        viewColumns: !isMobile,
        search: !isMobile,
        rowsPerPage: isMobile ? 20 : 10,
        rowsPerPageOptions: isMobile ? [20, 50, 100] : [5, 10, 15, 25, 50],
        fixedHeaderOptions: {
            xAxis: true,
            yAxis: true
        },
        resizableColumns: false,
        isRowExpandable: (dataIndex, expandedRows) => {
            // Prevent expand/collapse of any row if there are 4 rows expanded already (but allow those already expanded to be collapsed)
            if (expandedRows.data.length > 4 && expandedRows.data.filter(d => d.dataIndex === dataIndex).length === 0)
                return false;
            return true;
        },
        rowsExpanded: expandedRows,
        onRowExpansionChange: (curExpanded, allExpanded, rowsExpanded) => {
            setExpandedRows(allExpanded.map(r => r.dataIndex));
        },
        customToolbar: () => (<HeaderElements />),
        textLabels: {
            body: {
                noMatch: "No events found",
            },
            pagination: {
                rowsPerPage: isMobile ? "Rows:" : "Rows per page:",
            },
        },
        //onRowClick: (rowData, rowMeta) => {
        //    const detail = players[rowMeta.dataIndex];
        //    console.log(detail);
        //    if (props.sendToParentSelectedPlayer) {
        //        props.sendToParentSelectedPlayer(detail)
        //    }
        //    if (detail.fidePlayerId > 0) {
        //        if (props.sendToParentIdType) {
        //            props.sendToParentIdType("FIDE")
        //        }
        //        if (props.sendToParentPlayerId) {
        //            props.sendToParentPlayerId(detail.fidePlayerId)
        //        }
        //    } else {
        //        if (props.sendToParentIdType) {
        //            props.sendToParentIdType("USCF")
        //        }
        //        if (props.sendToParentPlayerId) {
        //            props.sendToParentPlayerId(detail.uscfPlayerId)
        //        }
        //    }
        //}
    };

    const tableTheme = createTheme({
        overrides: {
            MUIDataTableSelectCell: {
                expandDisabled: {
                    // Soft hide the button.
                    visibility: 'hidden',
                },
            },
            MUIDataTableBodyRow: {
                root: {
                    '&:nth-child(odd)': {
                        backgroundColor: '#FF0000'
                    }
                }
            },
        },
        components: {
            MuiTableCell: {
                styleOverrides: {
                    root: {
                        padding: isMobile ? '6px 4px' : '16px',
                    },
                },
            },
        },
    });

    const components = {
        ExpandButton: function (props) {
            return <ExpandButton {...props} />;
        },
    };

    return (
        <section>
            {events &&
                <Box sx={{ width: '100%', mt: 2, mb: 1, px: isMobile ? 1 : 0 }}>
                <Accordion m={2} pt={3} pl={0} pr={0} defaultExpanded={true}>
                    <AccordionSummary aria-controls="event-info" id="event-info" expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: '#1976d2' }}>
                        <Typography color='white' variant={isMobile ? "body2" : "body1"}>
                            {isMobile ? "Chess Events" : "Chess Events - "}
                            {!isMobile && <Link to="/Identity/Account/Register" style={{ color: 'white', textDecoration: 'underline' }}>Register</Link>}
                            {!isMobile && " an organizer account and publish your events to 5000+ players for free!"}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ px: isMobile ? 1 : 2 }}>
                        {isMobile && (
                            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
                                Tap a row to expand details
                            </Typography>
                        )}
                        <Grid item xs={12}>
                                <CacheProvider value={muiCache}>
                                    <ThemeProvider theme={tableTheme}>
                                        <MUIDataTable
                                            title={""}
                                            data={events}
                                            columns={columns}
                                            options={options}
                                            components={components}
                                        />
                                    </ThemeProvider>
                                </CacheProvider>
                        </Grid>
                    </AccordionDetails>
                    </Accordion>
                </Box>
            }
        </section>
    )
}